import { render, staticRenderFns } from "./GenericBtnAdd.vue?vue&type=template&id=2e5da852&scoped=true&"
import script from "./GenericBtnAdd.vue?vue&type=script&lang=js&"
export * from "./GenericBtnAdd.vue?vue&type=script&lang=js&"
import style0 from "./GenericBtnAdd.vue?vue&type=style&index=0&id=2e5da852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5da852",
  null
  
)

export default component.exports